import { ITriagem } from "../../../Interfaces/Geral/Email/EmailInterface";
import { IEmailTriagem } from "../../../Interfaces/Geral/Triagem";
import {
    BaixarEmailTriagemExcelService,
    DescartarEmailTriagemService,
    AdicionarEmailBlacklistService,
    IgnorarEmailTriagemService,
    ListarEmailBlacklistService,
    ListarEmailsTriagemComFiltroService,
    ListarEmailsTriagemService,
    RemoverEmailBlacklistService,
    VincularEmailTriagemService,
    VincularClienteEmailTriagemService,
    DesvincularClienteEmailTriagemService,
} from "../../../Services/Geral/Triagem/TriagemServices";
import { Controller } from "../../Controller";

export async function ListarEmailsTriagemController() {
    return Controller(ListarEmailsTriagemService());
}

export async function ListarEmailsTriagemComFiltroController(
    filtro: ITriagem,
    idTipoCaso?: number
) {
    return Controller(ListarEmailsTriagemComFiltroService(filtro, idTipoCaso));
}

export async function IgnorarEmailTriagemController(IdEmail: number) {
    return Controller(IgnorarEmailTriagemService(IdEmail));
}

export async function AdicionarEmailBlacklistController(dsEmail: string) {
    return Controller(AdicionarEmailBlacklistService(dsEmail));
}

export async function RemoverEmailBlacklistController(
    idEmailBlacklist: number
) {
    return Controller(RemoverEmailBlacklistService(idEmailBlacklist));
}

export async function ListarEmailBlacklistController() {
    return Controller(ListarEmailBlacklistService());
}

export const VincularEmailTriagemController = async (email: IEmailTriagem) =>
    Controller(VincularEmailTriagemService(email));

export async function DescartarEmailTriagemController(idsEmails: number[]) {
    return Controller(DescartarEmailTriagemService(idsEmails));
}

export async function BaixarEmailTriagemExcelController(requestBody: ITriagem) {
    return Controller(BaixarEmailTriagemExcelService(requestBody));
}

export async function VincularClienteEmailTriagemController(
    ID_CONTA: number,
    ID_EMAIL: number,
    ID_UNIDADE: number
) {
    return Controller(
        VincularClienteEmailTriagemService(ID_CONTA, ID_EMAIL, ID_UNIDADE)
    );
}

export async function DesvincularClienteEmailTriagemController(
    ID_EMAIL: number
) {
    return Controller(DesvincularClienteEmailTriagemService(ID_EMAIL));
}
